import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { BlogCategoryListComponent } from './blog-categoryList.component';


const routes: Routes = [
    {
        path: 'blog-categorylist',
        component: BlogCategoryListComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        BlogCategoryListComponent,

    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class BlogCategoryListModule {
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog-categoryList/blog-categoryList.module.ts